import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import { logoHeader } from "../../../assets/index";
import "./Sidemenu.css";

// MUI Icons
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SideMenu = () => {
  const location = useLocation();
  const path = location.pathname;
  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  const [excoExpanded, setExcoExpanded] = useState(true);

  let checkLevelExco = profile?.data?.id_tingkat_exco;
  let checkRoleLevelExco = profile?.data?.role;

  // level exco
  let levelExcoPusat =
    checkLevelExco === 1 &&
    (checkRoleLevelExco === 9 || checkRoleLevelExco === 1);
  let levelExcoProvinsi = checkLevelExco === 2 && checkRoleLevelExco === 9;
  let levelExcoKabKot = checkLevelExco === 3 && checkRoleLevelExco === 9;
  let levelExcoKecamatan = checkLevelExco === 4 && checkRoleLevelExco === 9;
  let levelExcoKelurahan = checkLevelExco === 5 && checkRoleLevelExco === 9;
  let levelExcoRTRW = checkLevelExco === 6 && checkRoleLevelExco === 9;
  let levelExcoKomisarisBasis = checkLevelExco === 7 && checkRoleLevelExco === 9;

  // cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  const hasDocumentAccess =
    checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ||
    checkHakAkses(profile?.data?.hak_akses, "Document Manager Access") ||
    checkHakAkses(profile?.data?.hak_akses, "Document Viewer Only Access");

  const isExcoPath = [
    "/provinsi",
    "/kab-kot",
    "/kecamatan",
    "/kelurahan",
  ].includes(path);

  return (
    <div className="SideNav">
      {/* Logo */}
      <div className="sidemenu-logo">
        <img src={logoHeader} alt="Partai Buruh" />
      </div>

      <nav style={{ padding: "8px 0" }}>
        {/* Ikhtisar */}
        {levelExcoPusat &&
          checkHakAkses(profile?.data?.hak_akses, "Overview Access") && (
            <Link
              to="/overview"
              className={`sidemenu-item ${path === "/overview" ? "sidemenu-item-active" : ""}`}
            >
              <DashboardOutlinedIcon className="sidemenu-icon" />
              <span className="sidemenu-text">Ikhtisar</span>
            </Link>
          )}

        {/* Profil Partai */}
        {levelExcoPusat && hasDocumentAccess && (
          <Link
            to="/"
            className={`sidemenu-item ${path === "/" ? "sidemenu-item-active" : ""}`}
          >
            <AccountBalanceOutlinedIcon className="sidemenu-icon" />
            <span className="sidemenu-text">Profil Partai</span>
          </Link>
        )}

        {/* EXCO Group */}
        {(levelExcoPusat ||
          levelExcoProvinsi ||
          levelExcoKabKot ||
          levelExcoKecamatan ||
          levelExcoKelurahan ||
          levelExcoRTRW ||
          levelExcoKomisarisBasis) &&
          (levelExcoPusat ? hasDocumentAccess : true) && (
            <div className="sidemenu-group">
              <div
                className={`sidemenu-group-header ${isExcoPath ? "sidemenu-group-header-active" : ""}`}
                onClick={() => setExcoExpanded(!excoExpanded)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FolderOutlinedIcon className="sidemenu-icon" />
                  <span className="sidemenu-text">EXCO</span>
                </div>
                <ExpandMoreIcon
                  className={`sidemenu-chevron ${excoExpanded ? "sidemenu-chevron-open" : ""}`}
                />
              </div>

              {excoExpanded && (
                <div className="sidemenu-group-content">
                  {/* Provinsi */}
                  {(levelExcoPusat || levelExcoProvinsi) && (
                    <Link
                      to="/provinsi"
                      className={`sidemenu-subitem ${path === "/provinsi" ? "sidemenu-subitem-active" : ""}`}
                    >
                      Provinsi
                    </Link>
                  )}

                  {/* Kab/Kota */}
                  {(levelExcoPusat || levelExcoProvinsi || levelExcoKabKot) && (
                    <Link
                      to="/kab-kot"
                      className={`sidemenu-subitem ${path === "/kab-kot" ? "sidemenu-subitem-active" : ""}`}
                    >
                      Kab/Kota
                    </Link>
                  )}

                  {/* Kecamatan */}
                  {(levelExcoPusat ||
                    levelExcoProvinsi ||
                    levelExcoKabKot ||
                    levelExcoKecamatan) && (
                    <Link
                      to="/kecamatan"
                      className={`sidemenu-subitem ${path === "/kecamatan" ? "sidemenu-subitem-active" : ""}`}
                    >
                      Kecamatan
                    </Link>
                  )}

                  {/* Kelurahan/Desa */}
                  {(levelExcoPusat ||
                    levelExcoProvinsi ||
                    levelExcoKabKot ||
                    levelExcoKecamatan ||
                    levelExcoKelurahan) && (
                    <Link
                      to="/kelurahan"
                      className={`sidemenu-subitem ${path === "/kelurahan" ? "sidemenu-subitem-active" : ""}`}
                    >
                      Kelurahan/Desa
                    </Link>
                  )}

                  {/* Komisaris Basis */}
                  {(levelExcoPusat || levelExcoProvinsi || levelExcoKabKot || levelExcoRTRW || levelExcoKomisarisBasis) && (
                    <Link
                      to="/komisaris-basis"
                      className={`sidemenu-subitem ${path === "/komisaris-basis" ? "sidemenu-subitem-active" : ""}`}
                      // style={{ opacity: 0.5, pointerEvents: "none" }}
                    >
                      Komisaris Basis
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}

        {/* Pengaturan Pengguna */}
        {levelExcoPusat &&
          checkHakAkses(profile?.data?.hak_akses, "User Management Access") && (
            <Link
              to="/user-management"
              className={`sidemenu-item ${path === "/user-management" ? "sidemenu-item-active" : ""}`}
            >
              <PeopleOutlineIcon className="sidemenu-icon" />
              <span className="sidemenu-text">Pengaturan Pengguna</span>
            </Link>
          )}
      </nav>
    </div>
  );
};

export default SideMenu;
